/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1DocumentCourseRegistrationCourseregistrationid200,
  GetApiV1DocumentCourseRegistrationCourseregistrationid401,
  GetApiV1DocumentCourseRegistrationCourseregistrationid404,
  GetApiV1DocumentCourseRegistrationCourseregistrationid500,
  GetApiV1DocumentCourseRegistrationCourseregistrationidPathParams,
  GetApiV1DocumentCourseRegistrationCourseregistrationidQueryParams,
  GetApiV1DocumentCourseRegistrationCourseregistrationidQueryResponse,
} from "../../types/documentCourseRegistrationController/GetApiV1DocumentCourseRegistrationCourseregistrationid.ts";
import { courseDocumentsViewModelSchema } from "../courseDocumentsViewModelSchema.ts";

export const getApiV1DocumentCourseRegistrationCourseregistrationidPathParamsSchema =
  z.object({
    courseRegistrationId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1DocumentCourseRegistrationCourseregistrationidPathParams>;

export const getApiV1DocumentCourseRegistrationCourseregistrationidQueryParamsSchema =
  z
    .object({
      cultureInfo: z.optional(z.string()),
    })
    .optional() as unknown as ToZod<GetApiV1DocumentCourseRegistrationCourseregistrationidQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1DocumentCourseRegistrationCourseregistrationid200Schema =
  z.array(
    z.lazy(() => courseDocumentsViewModelSchema),
  ) as unknown as ToZod<GetApiV1DocumentCourseRegistrationCourseregistrationid200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1DocumentCourseRegistrationCourseregistrationid401Schema =
  z.any() as unknown as ToZod<GetApiV1DocumentCourseRegistrationCourseregistrationid401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1DocumentCourseRegistrationCourseregistrationid404Schema =
  z.any() as unknown as ToZod<GetApiV1DocumentCourseRegistrationCourseregistrationid404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1DocumentCourseRegistrationCourseregistrationid500Schema =
  z.any() as unknown as ToZod<GetApiV1DocumentCourseRegistrationCourseregistrationid500>;

export const getApiV1DocumentCourseRegistrationCourseregistrationidQueryResponseSchema =
  z.lazy(
    () => getApiV1DocumentCourseRegistrationCourseregistrationid200Schema,
  ) as unknown as ToZod<GetApiV1DocumentCourseRegistrationCourseregistrationidQueryResponse>;
